import React from "react";
import { Select, SelectProps } from "antd";
import styled from "@emotion/styled";

interface Option {
  label: string;
  value: string | number;
}

interface CustomSelectBoxProps extends SelectProps<any> {
  options?: Option[];
  onChange?: SelectProps["onChange"];
  value?: string | number;
  name?: string;
  style?: React.CSSProperties;
  placeholder?: string;
  children?: React.ReactNode;
}

const CustomSelectBox: React.FC<CustomSelectBoxProps> = ({
  options,
  onChange,
  children,
  placeholder,
  name,
  ...props
}) => {
  return (
    <StyledSelect
      {...props}
      onChange={(value, option) => {
        if (onChange) {
          onChange(value, option);
        }
      }}>
      <Select.Option value="" disabled hidden>
        <Placeholder>{placeholder ? placeholder : ""}</Placeholder>
      </Select.Option>
      {options
        ? options.map((option) => (
            <Select.Option key={option.value} value={option.value}>
              <Options>{option.label}</Options>
            </Select.Option>
          ))
        : children}
    </StyledSelect>
  );
};

export default CustomSelectBox;

const StyledSelect = styled(Select)({
  ".ant-select-selector": {
    height: "5.2rem !important",
    borderRadius: "0rem",
    fontSize: "1.6rem",
    padding: "0 1.6rem !important", // 내부 좌우 패딩 추가
    display: "flex",
    alignItems: "center",
  },
  "&.ant-select-single": {
    height: "100%",
  },
  ".ant-select-selection-search": {
    marginLeft: "0.4rem", // 검색 입력 필드 위치 조정
  },
  ".ant-select-selection-item": {
    lineHeight: "5.2rem", // 선택된 항목 수직 정렬
  },
  ".ant-select-arrow": {
    right: "1.6rem",
  },
});

const Placeholder = styled.div(({ theme }) => ({
  color: theme.color.light_gray,
}));

const Options = styled.div({
  fontFamily: "Pretendard !important",
  fontSize: "1.6rem",
});
